<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Home</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.name }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Create Deploy Token
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Create deploy token</h2>
            <span class="sm-text"></span>
        </template>
        <div class="box-style">
            <jet-form-section @submitted="createApiToken">
                <template #form>
                    <div class="box-section">
                        <div class="box-content">
                            <jet-label for="username" value="User Name" class="small"/>
                            <jet-input id="username" type="text" class="form-control input-style" autofocus v-model="createApiTokenForm.username"/>
                            <jet-input-error :message="createApiTokenForm.errors.username" class="mt-2" />
                        </div>
                    </div>
                    <p class="box-text">This username will be used to authenticate via Helm command line tool.</p>
<!--                    <div class="box-section">-->
<!--                        <div class="box-content">-->
<!--                            <jet-label for="expires_at" value="Expires at" class="small"/>-->
<!--                            <jet-input id="expires_at" type="text" class="form-control input-style" autofocus />-->
<!--                            <jet-input-error :message="createApiTokenForm.errors.expires_at" class="mt-2" />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <p class="box-text">Set the expiration date for the token. Use mm/dd/yy or dd.mm.yyyy format</p>-->
                    <div class="box-section">
                        <div class="box-content">
                            <h5>Token access scope</h5>
                            <div class="radio">
                                <input id="read-only" name="radio" type="radio" value="ro" checked v-model="createApiTokenForm.scope" />
                                <label for="read-only" class="radio-label">Read-only</label>
                            </div>
                            <div class="radio">
                                <input id="read-write" name="radio" type="radio" value="rw" v-model="createApiTokenForm.scope" />
                                <label  for="read-write" class="radio-label">Read/write</label>
                            </div>
                            <jet-input-error :message="createApiTokenForm.errors.scope" class="mt-2" />
                        </div>
                    </div>
                    <p class="box-text">
                        Read-only keys allow the downloading and installing of the helm charts.<br>
                        Read-write keys allow the publication of new helm charts.
                    </p>

                    <div class="btn-icon-style">
                        <jet-button :class="{ 'opacity-25': createApiTokenForm.processing }" :disabled="createApiTokenForm.processing">
                            <span>Create Token</span>
                        </jet-button>
                    </div>
                </template>
            </jet-form-section>
        </div>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import JetFormSection from '@/Jetstream/FormSection';
    import JetInputError from '@/Jetstream/InputError';
    import JetLabel from '@/Jetstream/Label';
    import JetInput from '@/Jetstream/Input';
    import JetButton from '@/Jetstream/Button';

    export default {
        name: "DeployToken",
        components: {
            MainLayout,
            JetFormSection,
            JetInputError,
            JetLabel,
            JetInput,
            JetButton
        },
        props: ['team'],
        data() {
            return {
                createApiTokenForm: this.$inertia.form({
                    username: '',
                    expires_at: '',
                    scope: '',
                }),
            }
        },
        methods: {
            createApiToken() {
                this.createApiTokenForm.post(route('repository-settings.deploy-token.store', this.team), {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (response) => {
                        console.log('success?', response);
                    }
                })

            }
        }
    }
</script>

<style scoped>

</style>
